import * as React from 'react'

function DeleteIcon(props) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='22'
      viewBox='0 0 17 22'
      fill='none'
    >
      <path
        d='M0.5 4.5H16.5V17C16.5 19.4853 14.4853 21.5 12 21.5H5C2.51472 21.5 0.5 19.4853 0.5 17V4.5Z'
        fill='black'
        stroke='white'
      />
      <path
        d='M3.55001 2.5C3.78164 1.35888 4.79052 0.5 6 0.5H11C12.2095 0.5 13.2184 1.35888 13.45 2.5H3.55001Z'
        fill='white'
        stroke='black'
      />
      <line x1='4.5' y1='7' x2='4.5' y2='18' stroke='white' />
      <line x1='12.5' y1='7' x2='12.5' y2='18' stroke='white' />
      <line x1='8.5' y1='7' x2='8.5' y2='18' stroke='white' />
      <rect y='2' width='17' height='2' fill='black' />
    </svg>
  )
}

export default DeleteIcon
